import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement("g", { clipPath: "url(#warning-circle-filled_svg__clip0_5221_247361)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 0a12.24 12.24 0 00-8.53 3.65A11.85 11.85 0 000 12.21 11.78 11.78 0 0011.8 24h.2a12.11 12.11 0 0012-12.21A11.768 11.768 0 0012 0zm-1.5 16.54A1.48 1.48 0 0112 15a1.53 1.53 0 011.52 1.47A1.469 1.469 0 0112.05 18a1.53 1.53 0 01-1.55-1.46zm.5-4v-6a1 1 0 012 0v6a1 1 0 11-2 0z",
      fill: "#333"
    }
  )),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "warning-circle-filled_svg__clip0_5221_247361" }, /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h24v24H0z" })))
), a = t;
export {
  a as default
};
